(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hb-prelander-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(value) {
      var text = String(value);
      return text.length < 2 ? '0' + text : text;
    }

    function getEasternTimeParts(date) {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23',
      }).formatToParts(date);

      function value(type) {
        var part = parts.find(function (entry) {
          return entry.type === type;
        });
        return part ? parseInt(part.value, 10) : 0;
      }

      return {
        hour: value('hour'),
        minute: value('minute'),
        second: value('second'),
      };
    }

    function getEndOfEasternDay(now) {
      now = now || new Date();
      var eastern = getEasternTimeParts(now);
      var currentSecs = eastern.hour * 3600 + eastern.minute * 60 + eastern.second;
      var endOfDaySecs = 23 * 3600 + 59 * 60 + 59;
      var remainingMs = (endOfDaySecs - currentSecs) * 1000 + (999 - now.getMilliseconds());
      return new Date(now.getTime() + remainingMs);
    }

    document.querySelectorAll('[data-hb-countdown]').forEach(function (root) {
      if (root.dataset.hbCountdownBound === 'true') return;
      root.dataset.hbCountdownBound = 'true';

      var dailyEt = root.getAttribute('data-daily-et') === 'true';
      var fixedEnd = Date.parse(root.getAttribute('data-end') || '');

      var units = {
        days: root.querySelector('[data-unit="days"]'),
        hours: root.querySelector('[data-unit="hours"]'),
        minutes: root.querySelector('[data-unit="minutes"]'),
        seconds: root.querySelector('[data-unit="seconds"]'),
      };

      function tick() {
        var now = new Date();
        var target = dailyEt ? getEndOfEasternDay(now) : new Date(fixedEnd);
        if (!dailyEt && Number.isNaN(target.getTime())) return;

        var remaining = Math.max(0, target.getTime() - now.getTime());
        var total = Math.floor(remaining / 1000);
        if (units.days) units.days.textContent = pad(Math.floor(total / 86400));
        if (units.hours) units.hours.textContent = pad(Math.floor((total % 86400) / 3600));
        if (units.minutes) units.minutes.textContent = pad(Math.floor((total % 3600) / 60));
        if (units.seconds) units.seconds.textContent = pad(total % 60);
      }

      tick();
      window.setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-prelander"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function moneyText(button, name) {
      return button.getAttribute(name) || '';
    }

    function cartRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function formatCartMoney(cents, currencyCode) {
      var amount = (Math.max(0, Number(cents) || 0) / 100);
      var code = currencyCode || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: code,
          minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
          maximumFractionDigits: 2,
        }).format(amount);
      } catch (error) {
        return '$' + amount.toFixed(2);
      }
    }

    function syncCheckoutDock(cart) {
      var docks = document.querySelectorAll('[data-hb-pl-dock]');
      if (!docks.length) return;

      var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
      var total = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
      var currency = (cart && cart.currency) || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

      docks.forEach(function (dock) {
        var visible = count > 0;
        dock.classList.toggle('is-visible', visible);
        dock.setAttribute('aria-hidden', visible ? 'false' : 'true');

        var checkoutTotal = dock.querySelector('[data-hb-pl-checkout-total]');
        if (checkoutTotal) {
          checkoutTotal.textContent = visible ? ' - ' + formatCartMoney(total, currency) : '';
        }

        var tab = dock.querySelector('[data-hb-pl-offer-tab]');
        if (!tab) return;

        var shippingThreshold = parseInt(dock.getAttribute('data-shipping-threshold'), 10) || 2800;
        var giftThreshold = parseInt(dock.getAttribute('data-gift-threshold'), 10) || 4200;
        var mysteryThreshold = parseInt(dock.getAttribute('data-mystery-threshold'), 10) || 5800;
        var offerIcon = dock.querySelector('.hb-pl__dock-icon');
        var offerEmoji = dock.querySelector('[data-hb-pl-offer-emoji]');

        function setOfferTabIcon(useGiftEmoji) {
          if (offerIcon) offerIcon.classList.toggle('is-hidden', !!useGiftEmoji);
          if (offerEmoji) {
            if (useGiftEmoji) {
              offerEmoji.removeAttribute('hidden');
              offerEmoji.setAttribute('aria-hidden', 'false');
            } else {
              offerEmoji.setAttribute('hidden', '');
              offerEmoji.setAttribute('aria-hidden', 'true');
            }
          }
        }

        if (!visible) {
          tab.textContent = 'One-Time offer';
          setOfferTabIcon(false);
          return;
        }

        if (total < shippingThreshold) {
          tab.textContent =
            'Spend ' + formatCartMoney(shippingThreshold - total, currency) + ' more to get FREE shipping';
            setOfferTabIcon(false);
        } else if (total < giftThreshold) {
          tab.textContent =
            'Spend ' + formatCartMoney(giftThreshold - total, currency) + ' more to get a FREE Red Pepper balm';
            setOfferTabIcon(false);
        } else if (total < mysteryThreshold) {
          tab.textContent =
            'Spend ' + formatCartMoney(mysteryThreshold - total, currency) + ' more to get a FREE Mystery Limited Edition';
          setOfferTabIcon(true);
        } else {
          tab.textContent = 'FREE Mystery Limited Edition unlocked';
          setOfferTabIcon(true);
        }
      });
    }

    function refreshCheckoutDock() {
      return requestJson(cartRoot() + 'cart.js')
        .then(function (cart) {
          syncCheckoutDock(cart);
          return cart;
        })
        .catch(function () {
          syncCheckoutDock({ item_count: 0, total_price: 0 });
        });
    }

    function requestJson(url, options) {
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open((options && options.method) || 'GET', url, true);
        xhr.setRequestHeader('Accept', 'application/json');
        if (options && options.body) xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = function () {
          if (xhr.status < 200 || xhr.status >= 300) {
            reject(new Error('request failed'));
            return;
          }
          try {
            resolve(JSON.parse(xhr.responseText));
          } catch (error) {
            reject(error);
          }
        };
        xhr.onerror = function () {
          reject(new Error('network'));
        };
        xhr.send(options && options.body ? options.body : null);
      });
    }

    function visibleCartIcon() {
      var icons = document.querySelectorAll('.hb-header__cart');
      for (var i = 0; i < icons.length; i++) {
        var rect = icons[i].getBoundingClientRect();
        if (rect.width > 0 && rect.height > 0) return icons[i];
      }
      return null;
    }

    function closeCartSurfaces() {
      if (typeof window.upcartCloseCart === 'function') {
        try {
          window.upcartCloseCart();
        } catch (error) {}
      }
      document.querySelectorAll('#UpcartPopup, #CartPopup, .upcart-cart, .upcart-backdrop, #UpcartPopupBackDrop').forEach(function (el) {
        el.classList.remove('upcartPopupShow', 'styles_active__');
      });
      var drawer = document.getElementById('cart-drawer');
      if (drawer && drawer.hasAttribute('open') && typeof drawer.close === 'function') drawer.close();
    }

    function flyImageToCart(card) {
      return new Promise(function (resolve) {
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var shot = card ? card.querySelector('.hb-pl__viewport') || card.querySelector('.hb-pl__shot') : null;
        var images = card ? card.querySelectorAll('.hb-pl__slide img') : [];
        var source = images[0] || null;
        if (shot) {
          var bounds = shot.getBoundingClientRect();
          images.forEach(function (image) {
            var rect = image.getBoundingClientRect();
            if (rect.width < 20) return;
            if (rect.left >= bounds.left - 12 && rect.right <= bounds.right + 12) source = image;
          });
        }
        var cart = visibleCartIcon();
        if (reduce || !source || !cart) {
          resolve(cart);
          return;
        }

        var from = source.getBoundingClientRect();
        var to = cart.getBoundingClientRect();
        var ghost = source.cloneNode(true);
        ghost.removeAttribute('srcset');
        ghost.removeAttribute('sizes');
        ghost.className = 'hb-pl__fly';
        ghost.style.left = from.left + 'px';
        ghost.style.top = from.top + 'px';
        ghost.style.width = from.width + 'px';
        ghost.style.height = from.height + 'px';
        document.body.appendChild(ghost);

        var dx = to.left + to.width / 2 - (from.left + from.width / 2);
        var dy = to.top + to.height / 2 - (from.top + from.height / 2);
        var finished = false;
        function finish() {
          if (finished) return;
          finished = true;
          if (ghost.parentNode) ghost.remove();
          resolve(cart);
        }

        ghost.addEventListener('transitionend', function (event) {
          if (event.propertyName === 'transform') finish();
        });
        window.setTimeout(finish, 800);
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            ghost.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(0.12)';
            ghost.style.opacity = '0.2';
          });
        });
      });
    }

    document.querySelectorAll('[data-hb-prelander]').forEach(function (root) {
      if (root.dataset.hbPrelanderBound === 'true') return;
      root.dataset.hbPrelanderBound = 'true';

      root.querySelectorAll('[data-hb-pl-card]').forEach(function (card) {
        var packs = card.querySelectorAll('[data-hb-pack]');

        function apply(button) {
          packs.forEach(function (pack) {
            var selected = pack === button;
            pack.classList.toggle('is-selected', selected);
            pack.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });

          var per = card.querySelector('[data-per]');
          var total = card.querySelector('[data-total]');
          var compare = card.querySelector('[data-compare]');
          var badge = card.querySelector('[data-badge]');
          var stamp = card.querySelector('[data-stamp-line]');
          var qty = card.querySelector('input[name="quantity"]');
          var atc = card.querySelector('[data-atc-price]');
          var atcCompare = card.querySelector('[data-atc-compare]');

          if (per) per.textContent = moneyText(button, 'data-per');
          if (total) total.textContent = moneyText(button, 'data-total');
          if (compare) compare.textContent = moneyText(button, 'data-compare');
          if (badge) badge.textContent = button.getAttribute('data-badge');
          if (stamp) stamp.textContent = button.getAttribute('data-stamp');
          if (qty) qty.value = button.getAttribute('data-qty');
          if (atc) atc.textContent = moneyText(button, 'data-total');
          if (atcCompare) {
            var compareText = moneyText(button, 'data-compare');
            atcCompare.textContent = compareText;
            atcCompare.hidden = !compareText;
          }
        }

        packs.forEach(function (button) {
          button.addEventListener('click', function () {
            apply(button);
          });
        });
      });

      root.querySelectorAll('[data-carousel]').forEach(function (carousel) {
        var viewport = carousel.querySelector('.hb-pl__viewport');
        var track = carousel.querySelector('.hb-pl__track');
        var slides = track ? track.querySelectorAll('.hb-pl__slide') : [];
        var dots = carousel.querySelectorAll('[data-dot]');
        if (!viewport || !track || slides.length < 2) return;

        var index = 0;
        var startX = 0;
        var startY = 0;
        var startOffset = 0;
        var dragging = false;
        var axis = '';

        function slideWidth() {
          return viewport.clientWidth;
        }

        function sizeSlides() {
          var w = slideWidth();
          slides.forEach(function (slide) {
            slide.style.flex = '0 0 ' + w + 'px';
            slide.style.width = w + 'px';
          });
          return w;
        }

        function moveTo(x, animate) {
          track.style.transition = animate ? 'transform 0.35s ease' : 'none';
          track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
        }

        function go(next) {
          index = Math.max(0, Math.min(slides.length - 1, next));
          moveTo(-index * sizeSlides(), true);
          dots.forEach(function (dot, dotIndex) {
            dot.classList.toggle('is-active', dotIndex === index);
          });
        }

        dots.forEach(function (dot) {
          dot.addEventListener('click', function (event) {
            event.stopPropagation();
            go(Number(dot.getAttribute('data-dot')));
          });
        });

        viewport.addEventListener('pointerdown', function (event) {
          if (event.button > 0) return;
          dragging = true;
          axis = '';
          startX = event.clientX;
          startY = event.clientY;
          startOffset = -index * slideWidth();
        });

        viewport.addEventListener('pointermove', function (event) {
          if (!dragging) return;
          var dx = event.clientX - startX;
          var dy = event.clientY - startY;
          if (!axis) {
            if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
            if (Math.abs(dy) > Math.abs(dx)) {
              dragging = false;
              return;
            }
            axis = 'x';
            track.style.transition = 'none';
            viewport.classList.add('is-dragging');
            viewport.setPointerCapture(event.pointerId);
          }
          var limit = (slides.length - 1) * slideWidth();
          var x = Math.min(0, Math.max(-limit, startOffset + dx));
          track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
        });

        function endDrag(event) {
          if (!dragging && axis !== 'x') return;
          var wasDragging = axis === 'x';
          dragging = false;
          axis = '';
          viewport.classList.remove('is-dragging');
          if (!wasDragging) return;
          var dx = event.clientX - startX;
          var threshold = Math.max(24, slideWidth() * 0.18);
          if (dx <= -threshold) go(index + 1);
          else if (dx >= threshold) go(index - 1);
          else go(index);
        }

        viewport.addEventListener('pointerup', endDrag);
        viewport.addEventListener('pointercancel', endDrag);
        window.addEventListener('resize', function () {
          go(index);
        });
        go(0);
      });

      root.querySelectorAll('[data-hb-flavor]').forEach(function (button) {
        button.addEventListener('click', function () {
          var id = button.getAttribute('data-hb-flavor');
          root.querySelectorAll('[data-hb-flavor]').forEach(function (chip) {
            chip.classList.toggle('is-active', chip.getAttribute('data-hb-flavor') === id);
          });
          var card = root.querySelector('[data-hb-pl-card="' + id + '"]');
          var grid = root.querySelector('.hb-pl__grid');
          if (!card || !grid) return;
          grid.prepend(card);
          var bar = root.querySelector('[data-hb-flavors]');
          var headerHeight = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-group-height')) || 0;
          var offset = headerHeight + (bar ? bar.getBoundingClientRect().height : 0) + 16;
          var top = window.scrollY + card.getBoundingClientRect().top - offset;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        });
      });

      root.addEventListener('submit', function (event) {
        var form = event.target.closest('[data-hb-pl-form]');
        if (!form || !root.contains(form)) return;
        event.preventDefault();

        var button = form.querySelector('.hb-pl__atc');
        var card = form.closest('[data-hb-pl-card]');
        if (button) button.disabled = true;

        var idInput = form.querySelector('[name="id"]');
        var qtyInput = form.querySelector('input[name="quantity"]');
        window.upcartShouldSkipAddToCartInterceptor = true;
        window.upcartShouldOpenOnAddToCartBackgroundNetworkCall = false;
        var themeDrawer = document.getElementById('cart-drawer');
        if (themeDrawer) themeDrawer.removeAttribute('auto-open');

        var flight = flyImageToCart(card);
        requestJson(cartRoot() + 'cart/add.js', {
          method: 'POST',
          body: JSON.stringify({
            id: idInput ? idInput.value : '',
            quantity: qtyInput ? Number(qtyInput.value) : 1,
          }),
        })
          .then(function () {
            return requestJson(cartRoot() + 'cart.js');
          })
          .then(function (cart) {
            return flight.then(function (icon) {
              return { cart: cart, icon: icon };
            });
          })
          .then(function (result) {
            if (typeof window.upcartRefreshCart === 'function') {
              try {
                window.upcartRefreshCart();
              } catch (error) {}
            }
            document.querySelectorAll('[data-hb-cart-count], .hb-header__cart-count').forEach(function (el) {
              el.textContent = result.cart.item_count;
              if (result.cart.item_count > 0) el.removeAttribute('hidden');
            });
            syncCheckoutDock(result.cart);
            if (result.icon) {
              result.icon.classList.remove('is-bump');
              void result.icon.offsetWidth;
              result.icon.classList.add('is-bump');
              window.setTimeout(function () {
                result.icon.classList.remove('is-bump');
              }, 320);
            }
            if (button) {
              button.disabled = false;
              button.classList.add('is-added');
              window.setTimeout(function () {
                button.classList.remove('is-added');
              }, 1200);
            }
          })
          .catch(function () {
            closeCartSurfaces();
            if (button) button.disabled = false;
            form.submit();
          });
      });
    });

    document.querySelectorAll('[data-hb-flavors]').forEach(function (bar) {
      if (bar.dataset.hbFlavorStuck === 'true') return;
      bar.dataset.hbFlavorStuck = 'true';

      var desktop = window.matchMedia('(min-width: 990px)');

      function placeUnderBanner() {
        var banner = document.querySelector('.hb-plb-section');
        var height = banner ? Math.ceil(banner.getBoundingClientRect().height) : 88;
        bar.style.setProperty('--hb-plb-offset', height + 'px');
      }

      function stickyTop() {
        placeUnderBanner();
        return parseFloat(getComputedStyle(bar).top) || 0;
      }

      function update() {
        if (!desktop.matches) {
          bar.classList.remove('is-stuck');
          bar.style.setProperty('--hb-plb-offset', '103px');
          return;
        }
        var limit = stickyTop();
        bar.classList.toggle('is-stuck', bar.getBoundingClientRect().top <= limit + 2);
      }

      update();
      document.addEventListener('scroll', update, { passive: true, capture: true });
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      if (desktop.addEventListener) desktop.addEventListener('change', update);
      window.setTimeout(update, 300);
    });

    function scheduleCheckoutDockRefresh() {
      window.clearTimeout(window.__hbPlDockRefreshTimer);
      window.__hbPlDockRefreshTimer = window.setTimeout(function () {
        refreshCheckoutDock();
      }, 120);
    }

    function isCartMutationUrl(url) {
      var href = String(url || '');
      return (
        href.indexOf('/cart/change') !== -1 ||
        href.indexOf('/cart/update') !== -1 ||
        href.indexOf('/cart/clear') !== -1 ||
        href.indexOf('/cart/add') !== -1
      );
    }

    if (!window.__hbPlDockFetchPatched && typeof window.fetch === 'function') {
      window.__hbPlDockFetchPatched = true;
      var nativeFetch = window.fetch.bind(window);
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : input && input.url;
        return nativeFetch(input, init).then(function (response) {
          if (isCartMutationUrl(url)) scheduleCheckoutDockRefresh();
          return response;
        });
      };
    }

    if (!window.__hbPlDockXhrPatched && window.XMLHttpRequest) {
      window.__hbPlDockXhrPatched = true;
      var nativeOpen = XMLHttpRequest.prototype.open;
      var nativeSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) {
        this.__hbPlCartUrl = url;
        return nativeOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function () {
        if (isCartMutationUrl(this.__hbPlCartUrl)) {
          this.addEventListener('loadend', scheduleCheckoutDockRefresh);
        }
        return nativeSend.apply(this, arguments);
      };
    }

    refreshCheckoutDock();
    document.addEventListener('cart:updated', scheduleCheckoutDockRefresh);
    document.addEventListener('cart:change', scheduleCheckoutDockRefresh);
    document.addEventListener('cart:refresh', scheduleCheckoutDockRefresh);
    window.addEventListener('pageshow', scheduleCheckoutDockRefresh);

    [
      'upcart:updated',
      'upcart:cartUpdated',
      'upcart:lineItemRemoved',
      'upcart:quantityChanged',
      'upcart:opened',
      'upcart:closed',
    ].forEach(function (eventName) {
      document.addEventListener(eventName, scheduleCheckoutDockRefresh);
      window.addEventListener(eventName, scheduleCheckoutDockRefresh);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-prelander2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot(root) {
      if (root.dataset.hbPl2Bound === 'true') return;
      root.dataset.hbPl2Bound = 'true';

      var need = parseInt(root.getAttribute('data-picks'), 10) || 3;
      var slots = Array.prototype.slice.call(root.querySelectorAll('[data-slot]'));
      var boxes = Array.prototype.slice.call(root.querySelectorAll('[data-hb-box]'));
      var cta = root.querySelector('[data-cta]');
      var label = cta.querySelector('[data-cta-label]');
      var picked = [];
      var reserved = [];
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var prizeOrder = [];
      var prizeCatalog = {};

      boxes.forEach(function (box) {
        var key = box.getAttribute('data-prize') || '';
        if (!key || prizeCatalog[key]) return;
        var sticker = box.querySelector('.hb-pl2__sticker');
        prizeOrder.push(key);
        prizeCatalog[key] = {
          html: box.querySelector('.hb-pl2__src').innerHTML,
          sticker: sticker ? sticker.getAttribute('src') : ''
        };
      });

      function held() {
        return picked.concat(reserved);
      }

      function usedPrizes() {
        return held().map(function (box) {
          return box.dataset.awarded || '';
        });
      }

      function choosePrize(box) {
        var used = usedPrizes();
        var own = box.getAttribute('data-prize') || '';
        if (own && used.indexOf(own) === -1) return own;
        for (var i = 0; i < prizeOrder.length; i++) {
          if (used.indexOf(prizeOrder[i]) === -1) return prizeOrder[i];
        }
        return '';
      }

      function applyPrize(box, key) {
        var gift = prizeCatalog[key];
        if (!gift) return;
        box.dataset.awarded = key;
        box.querySelector('.hb-pl2__src').innerHTML = gift.html;
        var sticker = box.querySelector('.hb-pl2__sticker');
        if (sticker && gift.sticker) sticker.setAttribute('src', gift.sticker);
      }

      function paint() {
        slots.forEach(function (slot, index) {
          var box = picked[index];
          var face = slot.querySelector('[data-face]');
          var cap = slot.querySelector('[data-cap]');
          face.innerHTML = '';
          cap.innerHTML = '';
          if (!box) {
            slot.classList.remove('is-filled');
            return;
          }
          var src = box.querySelector('.hb-pl2__src');
          Array.prototype.forEach.call(src.children, function (child) {
            if (child.classList.contains('hb-pl2__cap-src')) {
              cap.innerHTML = child.innerHTML;
            } else {
              face.appendChild(child.cloneNode(true));
            }
          });
          slot.classList.add('is-filled');
        });

        var ready = picked.length >= need;
        cta.classList.toggle('is-ready', ready);
        cta.setAttribute('aria-disabled', ready ? 'false' : 'true');
        label.textContent = ready ? cta.getAttribute('data-claim') : cta.getAttribute('data-idle');
      }

      function openBox(box) {
        if (box.dataset.busy === 'true') return;
        if (held().length >= need) return;
        if (picked.indexOf(box) !== -1 || reserved.indexOf(box) !== -1) return;
        var prize = choosePrize(box);
        if (!prize) return;

        applyPrize(box, prize);
        box.dataset.busy = 'true';
        reserved.push(box);
        paint();
        box.classList.add('is-shaking');
        window.setTimeout(function () {
          reserved = reserved.filter(function (item) { return item !== box; });
          box.classList.remove('is-shaking');
          box.classList.add('is-open', 'is-pop');
          picked.push(box);
          paint();
          window.setTimeout(function () {
            box.classList.remove('is-pop');
            box.dataset.busy = 'false';
          }, reduce ? 0 : 860);
        }, reduce ? 0 : 420);
      }

      boxes.forEach(function (box) {
        box.addEventListener('click', function () {
          openBox(box);
        });
      });

      cta.addEventListener('click', function (event) {
        if (cta.getAttribute('aria-disabled') === 'true' || !cta.getAttribute('href') || cta.getAttribute('href') === '#') {
          event.preventDefault();
        }
      });

      paint();
    }

    document.querySelectorAll('[data-hb-pl2]').forEach(boot);
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-hb-pl2]');
      if (root) boot(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
